import React, { useState, useEffect } from "react";
import { Modal, Select, Typography, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { CloseOutlined } from "@ant-design/icons";
import { assignEmployee } from "../../employeeDetails/employeeDetailsSlice";

const { Title } = Typography;

const { Option } = Select;

const AssignEmployee = (props) => {
  const { visible, hide, record } = props;
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const assignLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/assign"]
  );
  const profile = useSelector((state) => state.user.profile);
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    let arr = [];
    if (record && profile.branches) {
      profile.branches.forEach((item, i) => {
        const exists = record.active_branches.filter(
          (i) => i.id === item.id
        )[0];
        if (exists === undefined) {
          arr.push(item);
        }
      });
    }
    setItems(arr);
  }, [record, profile]);

  const onChange = (value) => {
    setSelected(value);
  };
  const onAssignClicked = async () => {
    const params = {
      branchId: selected,
      employeeId: record.id,
    };
    const action = await dispatch(assignEmployee(params));
    if (!action.error) {
      hide();
    }
  };

  const onHide = () => {
    setSelected(null);
    hide();
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={onHide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: "0px 100px 40px 100px",
        },
      }}
      destroyOnClose={true}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onHide}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0 ",
            textAlign: "center",
          }}
        >
          {intl.formatMessage({
            id: "app.employees.assignEmployeeTitle",
          })}
        </Title>
        <Select
          style={{ width: "200px" }}
          showSearch
          placeholder={intl.formatMessage({
            id: "app.users.chooseBranch",
          })}
          optionFilterProp="children"
          onChange={onChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {items.map((b) => (
            <Option value={b.id} key={b.id}>
              {b.name}
            </Option>
          ))}
        </Select>
        <Button
          style={{ width: "fit-content", marginTop: "20px" }}
          type="primary"
          disabled={!selected}
          onClick={onAssignClicked}
          loading={assignLoading}
        >
          {intl.formatMessage({
            id: "app.employees.assignEmployee",
          })}
        </Button>
      </div>
    </Modal>
  );
};

export default AssignEmployee;
